import { Pipe, PipeTransform } from '@angular/core';
import { conformToMask } from 'angular2-text-mask';

@Pipe({
  name: 'phoneNumber'
})

export class PhoneNumberPipe implements PipeTransform {
  transform(phoneNumber: string | undefined | number): string {
    const mask = ['+', /[1-9]/, ' ', /[1-9]/, /\d/, /\d/, ' ', /\d/, /\d/, /\d/, ' ', /\d/, /\d/, ' ', /\d/, /\d/];
    phoneNumber = '' + phoneNumber;
    const result = conformToMask(
      phoneNumber ? phoneNumber : '',
      mask,
      {guide: false}
    );
    return result.conformedValue;
  }
}
